export var InputSizes;
(function (InputSizes) {
    InputSizes["Small"] = "small";
    InputSizes["Standard"] = "standard";
})(InputSizes || (InputSizes = {}));
export var CheckboxRadioAlign;
(function (CheckboxRadioAlign) {
    CheckboxRadioAlign["Top"] = "alignTop";
    CheckboxRadioAlign["Center"] = "alignCenter";
})(CheckboxRadioAlign || (CheckboxRadioAlign = {}));
